import { Component, Input, OnInit } from '@angular/core';
import { getAvatarInitials, getAvatarProfileType, shouldShowAvatarImage } from 'app/utils/helpers/avatar.helper';

@Component({
    selector: 'app-profile-avatar',
    templateUrl: './profile-avatar.component.html',
    styleUrls: ['./profile-avatar.component.scss'],
    standalone: false,
})
export class ProfileAvatarComponent implements OnInit {
    @Input() imageUrl: string = '';
    @Input() fullName: string = '';
    @Input() imgClass: string = '';
    @Input() wrapperClass: string = '';
    @Input() alt = 'Profile avatar';
    initials: string = '';

    get showImage(): boolean {
        return shouldShowAvatarImage(this.imageUrl);
    }

    get profileType(): string {
        return getAvatarProfileType(this.imageUrl);
    }

    ngOnInit() {
        this.initials = getAvatarInitials(this.fullName);
    }
}
